export default "__VITE_ASSET__73696aba__"